export default __webpack_public_path__ + "static/identity-mock-m12-c2025392c3909484ab4363873aac2e6e.png";